export default "__VITE_ASSET__rvQ8LP$4__"